import React from 'react'
import { CircleStyle } from '../../styles/styles';

type CircleProps = { color: string, borderColor: string, width: string, dashed?: boolean };

function Circle({ color, borderColor, width, dashed }: CircleProps) {
  return (
    <div><CircleStyle color={color} size={width} borderColor={borderColor}/></div>
  )
}

export default Circle